// Quelle der Wahrheit fuer den Demo-Modus im Frontend.
// Wird via .env / Build-Time gesetzt (VITE_READ_ONLY_MODE=true).
// In dieser Phase blockt das Backend Mutations mit 423 — UI-Flows
// liefern stattdessen einen client-seitigen Mock.
//
// Fail-safe: nur explizit VITE_READ_ONLY_MODE=false gilt als Live; alles andere
// (inkl. fehlend/malformiert) = Demo — konsistent zum Backend-Read-only-Default.
export function resolveDemoMode(readOnlyEnv: string | undefined): boolean {
  return readOnlyEnv !== 'false'
}

export const IS_DEMO_MODE: boolean = resolveDemoMode(import.meta.env.VITE_READ_ONLY_MODE)
